import subscriptionsPath from './Subscriptions/path'
import changePasswordPath from './ChangePassword/path'

export const settingsTabs = {
  user:{
    name: 'user',
    icon: 'user',
    path: '/settings/user',
    label: 'Account',
  },
  // mailboxes:{
  //   name: 'mailboxes',
  //   icon: 'mailboxes',
  //   path: '/settings/mailboxes',
  //   label: 'Email Accounts',
  // },
  // schedules:{
  //   name: 'schedules',
  //   icon: 'schedules',
  //   path: '/settings/schedules',
  //   label: 'Schedules',
  // },
  subscriptions:{
    name: 'subscriptions',
    icon: 'subscriptions',
    path: subscriptionsPath,
    label: 'Billing',
  },
  // integrations:{
  //   name: 'integrations',
  //   icon: 'integrations',
  //   path: '/settings/integrations',
  //   label: 'Integrations',
  // }
  password:{
    name: 'password',
    icon: 'reset_pass',
    path: changePasswordPath,
    label: 'Change Password',
  },
};
